import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root'
})
export class AccountsservicesService {

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }


  async addamount(formData:any , account_type:any){

    const model={
      date : formData.date,
      amount: formData.total_amount,
      expense_type: formData.type,
      description : formData.description,
      account_type : account_type
    }
    return this.httpClient
    .post(this.Customeroutes.addamount(), model, {
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {
      if (data.success == true) {
        return data;
      }
      return data;
    });
  }


  async getamountdetail(){

    return this.httpClient
    .post(this.Customeroutes.getAmount(), '',{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }

  async getuserdetail() {
    return this.httpClient
      .get(this.Customeroutes.userdetail(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }
  async getadmindatadetail(id:any){
    return this.httpClient
      .get(this.Customeroutes.getadmindeail(id), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }







  async getadmindetail(){
    return this.httpClient
    .post(this.Customeroutes.getadmins(), '',{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }





  async getchartdetail(id:any){
    return this.httpClient
    .post(this.Customeroutes.getchart(), id,{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }




  async getuseramountdetail(id:any){
    return this.httpClient
    .post(this.Customeroutes.gettrasaction(), id,{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }


  async getadminalldetail(){
    return this.httpClient
    .post(this.Customeroutes.getadminAll(),'',{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });


  }



  async getadminamountdetail(id:any){
    return this.httpClient
    .get(this.Customeroutes.getadmintrasaction(id), {
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),

    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }






  async reservecal(form_data :any, account_type:any){
    const model={
      date : form_data.date,
      amount: form_data.total_amount,
      expense_type: form_data.type,
      description : form_data.description,
      account_type : account_type
    }
    return this.httpClient
    .post(this.Customeroutes.getreservecal(), model,{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }






  async editeacount(formData:any , account_id:any , account_type:any){

    const update={
        id : account_id,
        date : formData.date,
        amount: formData.total_amount,
        expense_type: formData.type || null ,
        description : formData.description,
        account_type : account_type

    }
    return this.httpClient
    .post(this.Customeroutes.getupdateaccount(), update,{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }


  async deleteacount(id :any){
  const modal={
    id:id
  }
  return this.httpClient
  .post(this.Customeroutes.getdeleteaccount(), modal,{
    headers: this.HeaderService.getHeaderWithToken(
      localStorage.getItem('token')
    ),
  })
  .pipe()
  .toPromise()
  .then((data: any) => {

    if (data) {
      if (data.success == true) {

        return data;
      }
    }
    return data;
  });
}



async getamountfilter(startDate:any ,endDate:any){
  const modal={
    start_date:startDate,
    end_date : endDate
  }
  return this.httpClient
  .post(this.Customeroutes.getfilteraccount(), modal,{
    headers: this.HeaderService.getHeaderWithToken(
      localStorage.getItem('token')
    ),
  })
  .pipe()
  .toPromise()
  .then((data: any) => {

    if (data) {
      if (data.success == true) {

        return data;
      }
    }
    return data;
  });
}


 async getcatdetail(){
    return this.httpClient
    .post(this.Customeroutes.getCatAll(),'',{
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {

      if (data) {
        if (data.success == true) {

          return data;
        }
      }
      return data;
    });
  }






}
